import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { accountService, alertService } from '../_services';
import { updateUserInfo } from '../_firebase';

function Update({ history }) {
    const {t} = useTranslation();
    const user = accountService.userValue;
    const firstName = user.firstName? user.firstName : user.displayName.split(' ')[0];
    const lastName = user.lastName? user.lastName : user.displayName.split(' ')[1];
    const initialValues = {
        title: user.title,
        firstName: firstName === "MobileLogin" ? "" : firstName,
        lastName: lastName,
        address: user.address
    };

    const validationSchema = Yup.object().shape({
        title: Yup.string()
            .required(t('Title') + t('isRequired')),
        firstName: Yup.string()
            .required(t('FirstName') + t('isRequired')),
        lastName: Yup.string(),
        address: Yup.string()        
    });

    function onSubmit(fields, { setStatus, setSubmitting }) {
        setStatus();
        updateUserInfo(user.id, user, fields)
            .then(() => {
                alertService.success(t("msgUpdateSuccess"), { keepAfterRouteChange: true });
                accountService.userSubject.next( { ...user, ...fields, displayName: fields.firstName + ' ' + fields.lastName });
                history.push('.');
            })
            .catch(error => {
                setSubmitting(false);
                alertService.error(error);
            });
    }
   

    return (
        <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ errors, touched, isSubmitting }) => (
                <Form>
                    <h3 className='mb-3'>{t("UpdateProfile")} </h3>
                    <div className="form-row">
                        <div className="form-group col">
                            <label>{t("Title")}</label>
                            <Field name="title" as="select" className={'form-control' + (errors.title && touched.title ? ' is-invalid' : '')}>
                                <option value=""></option>
                                <option value="Mr">Mr</option>
                                <option value="Mrs">Mrs</option>
                                <option value="Miss">Miss</option>
                                <option value="Ms">Ms</option>
                            </Field>
                            <ErrorMessage name="title" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group col-5">
                            <label>{t("FirstName")}</label>
                            <Field name="firstName" type="text" className={'form-control' + (errors.firstName && touched.firstName ? ' is-invalid' : '')} />
                            <ErrorMessage name="firstName" component="div" className="invalid-feedback" />
                        </div>
                        <div className="form-group col-5">
                            <label>{t("LastName")}</label>
                            <Field name="lastName" type="text" className={'form-control' + (errors.lastName && touched.lastName ? ' is-invalid' : '')} />
                            <ErrorMessage name="lastName" component="div" className="invalid-feedback" />
                        </div>
                    </div>
                    <div className="form-group">
                        <label>{t("Address")}</label>
                        <Field name="address" type="text" className={'form-control' + (errors.address && touched.address ? ' is-invalid' : '')} />
                        <ErrorMessage name="address" component="div" className="invalid-feedback" />
                    </div>
                    
                    <div className="form-group">
                        <button type="submit" disabled={isSubmitting} className="btn btn-primary mr-2">
                            {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                            {t("Update")}
                        </button>
                        
                        <Link to="." className="btn btn-link">{t("Cancel")}</Link>
                    </div>
                </Form>
            )}
        </Formik>
    )
}

export { Update };